import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { Folder } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

@Injectable({
	providedIn: 'root',
})
export class BusinessFoldersService extends Repo<Folder, unknown> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(): string {
		return CollectionPaths.business_folders(this.businessId);
	}
}
